import type { Mentor, LandingMentor } from "@/types/mentor";

export function toSlug(nombre: string): string {
  return nombre
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");
}

export function getMentorBySlug(slug: string): Mentor | undefined {
  return mentores.find((m) => m.slug === slug);
}

export const mentoresLanding: LandingMentor[] = [
    {
    id: "61f70f79a8c6c31908409a6f",
    nombre: "Niel Arroe",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 25 }, 
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:  `Embajador Corona y pionero del Network Marketing en Perú. Autor de “La Fórmula del 1%”, fundador de la Universidad UDAXEN y creador del sistema Networker Pro, con más de 20 años formando líderes en la nueva economía.`,
    perfil: "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/NIEL+ARROE.jpg",
  },
  {
    id: "689a25f56cc6f51833fe790d",
    nombre: "Niel Arroe Atapoma",
    rango: "Embajador Corona",
    stats: { estudiantes: 1600, exp: 18 }, 
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion: "Co-fundador de la Universidad UDAXEN y co-creador de Networker Pro. Impulsor del “Sistema de los 8 Pasos del Éxito”, guía a emprendedores con enfoque en mentalidad, responsabilidad y construcción de legado.",
    perfil: "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/NIEL++ARROE+ATAPOMA.jpg",
  },
  {
    id: "696ffbefdacc39b703d3da6e",
    nombre: "Cesar Limaymanta",
    rango: "Embajador Corona",
    stats: { estudiantes: 1500, exp: 15 }, 
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion: "Investigador RENACYT | Catedratico | Conferencista |  Líder Global en Network Marketing | Mentor en la Universidad UDAXEN",
    perfil: "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/cesar-limaymanta.png",
  },
  {
    id: "689a26026cc6f51833fe790e",
    nombre: "Briguido Guizado",
    rango: "Embajador Corona",
    stats: { estudiantes: 1200, exp: 12 }, 
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion: "Psicólogo y teólogo, co-creador de Networker Pro y Mentor de Élite en UDAXEN. Integra ética, estrategia y desarrollo humano para elevar la conciencia y el liderazgo de emprendedores.",
    perfil: "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/brigido-guizado.png",
  },
]

export const mentores: Mentor[] = [
  {
    id: "61f70f79a8c6c31908409a6f",
    nombre: "Niel Arroe",
    slug: "niel-arroe",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      'Embajador Corona y pionero del Network Marketing en Perú. Autor de "La Fórmula del 1%", fundador de la Universidad UDAXEN y creador del sistema Networker Pro, con más de 20 años formando líderes en la nueva economía.',
    biografia:
      'Niel Arroe es referente y pionero en una de las industrias Network Marketing en Perú, alcanzando el prestigio mundial como Embajador Corona. Autor del libro "La Fórmula del 1%" y fundador de la Universidad UDAXEN, es la mente maestra detrás del sistema Networker Pro. Su liderazgo no solo busca la libertad financiera, sino la excelencia mental y el propósito, consolidándose como el mentor de mentores en la nueva economía.',
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/NIEL+ARROE.jpg",
    socialLinks: {
      facebook:  "https://facebook.com/nielarroe",
      instagram: "https://instagram.com/nielarroe",
      youtube:   "https://youtube.com/@nielarroe",
      whatsapp:  "https://wa.me/51999999999",
    },
  },
  {
    id: "689a25f56cc6f51833fe790d",
    nombre: "Niel Arroe Atapoma",
    slug: "niel-arroe-atapoma",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      'Co-fundador de la Universidad UDAXEN y co-creador de Networker Pro. Impulsor del "Sistema de los 8 Pasos del Éxito", guía a emprendedores con enfoque en mentalidad, responsabilidad y construcción de legado.',
    biografia:
      'Co-fundador de la Universidad UDAXEN y co-creador de Networker Pro. Impulsor del "Sistema de los 8 Pasos del Éxito", guía a emprendedores con enfoque en mentalidad, responsabilidad y construcción de legado.',
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/NIEL++ARROE+ATAPOMA.jpg",
    socialLinks: { facebook: "https://facebook.com", instagram: "https://instagram.com" },
  },
  {
    id: "696ffbefdacc39b703d3da6e",
    nombre: "Cesar Limaymanta",
    slug: "cesar-limaymanta",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      "Investigador RENACYT | Catedrático | Conferencista | Líder Global en Network Marketing | Mentor en la Universidad UDAXEN.",
    biografia:
      "Investigador RENACYT | Catedrático | Conferencista | Líder Global en Network Marketing | Mentor en la Universidad UDAXEN.",
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/cesar-limaymanta.png",
    socialLinks: { linkedin: "https://linkedin.com", instagram: "https://instagram.com" },
  },
  {
    id: "689a26026cc6f51833fe790e",
    nombre: "Brigido Guizado",
    slug: "brigido-guizado",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      "Psicólogo y teólogo, co-creador de Networker Pro y Mentor de Élite en UDAXEN. Integra ética, estrategia y desarrollo humano para elevar la conciencia y el liderazgo de emprendedores.",
    biografia:
      "Brígido Guizado aporta la profundidad intelectual y psicológica al equipo. Como co-creador del sistema de formación Networker Pro y Mentor de Élite en UDAXEN, ha diseñado estrategias que fusionan la ética con el mercadeo de alto impacto. Su misión es elevar la conciencia de los líderes, transformando sus finanzas y su estructura mental para alcanzar una libertad integral.",
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/BRIGIDO.jpg",
    socialLinks: { facebook: "https://facebook.com", youtube: "https://youtube.com" },
  },
  {
    id: "698e1b80b11e07d14afaf302",
    nombre: "Juan Carlos Atoche",
    slug: "juan-carlos-atoche",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    biografia:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/juan-atoche.png",
    socialLinks: { facebook: "https://facebook.com", instagram: "https://instagram.com", tiktok: "https://tiktok.com" },
  },
  {
    id: "69716997e52f2b01b7b8c352",
    nombre: "Antonio Azpiroz",
    slug: "antonio-azpiroz",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    biografia:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/antonio-azpiroz.png",
    socialLinks: { instagram: "https://instagram.com", youtube: "https://youtube.com" },
  },
  {
    id: "69716997e52f2b01b7b8c353",
    nombre: "Cesar Baltodano",
    slug: "cesar-baltodano",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    biografia:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/cesar-baltodano.png",
    socialLinks: { facebook: "https://facebook.com", linkedin: "https://linkedin.com" },
  },
  {
    id: "69716997e52f2b01b7b8c354",
    nombre: "Jenny Liz",
    slug: "jenny-liz",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      "Egresada de Networker Pro y hoy mentora en UDAXEN. Acompaña a emprendedores en liderazgo y mentalidad empresarial, con una perspectiva práctica basada en resultados, constancia y autenticidad.",
    biografia:
      "Jenny Liz es el testimonio vivo de la transformación que ofrece nuestro sistema educativo. Su trayectoria es ejemplar: inició su camino como estudiante hasta GRADUARSE en Networker Pro y hoy, gracias a sus extraordinarios resultados, ejerce como mentora de la Universidad UDAXEN.",
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/jenny-liz.png",
    socialLinks: { instagram: "https://instagram.com", tiktok: "https://tiktok.com", whatsapp: "https://wa.me/51999999999" },
  },
  {
    id: "69716997e52f2b01b7b8c355",
    nombre: "Joaquin Cruzado",
    slug: "joaquin-cruzado",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      "Conferencista Internacional en Network Marketing, Orador apasionado por la comunicación, Fue educado en DXN desde los 7 años convirtiéndose en la persona más joven en pisar escenarios grandes.",
    biografia:
      "Conferencista Internacional en Network Marketing, Orador apasionado por la comunicación, Fue educado en DXN desde los 7 años convirtiéndose en la persona más joven en pisar escenarios grandes.",
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/joaquin-cruzado.png",
    socialLinks: { instagram: "https://instagram.com", youtube: "https://youtube.com", tiktok: "https://tiktok.com" },
  },
  {
    id: "69716997e52f2b01b7b8c356",
    nombre: "Maggie Palacios",
    slug: "maggie-palacios",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    biografia:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/maggie-palacios.png",
    socialLinks: { facebook: "https://facebook.com", instagram: "https://instagram.com" },
  },
  {
    id: "69716997e52f2b01b7b8c357",
    nombre: "Noel Sumaran",
    slug: "noel-sumaran",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    biografia:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/noel-sumaran.png",
    socialLinks: { facebook: "https://facebook.com", youtube: "https://youtube.com" },
  },
  {
    id: "69716997e52f2b01b7b8c358",
    nombre: "Pedro Chuco",
    slug: "pedro-chuco",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    biografia:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/pedro-chuco.png",
    socialLinks: { instagram: "https://instagram.com", whatsapp: "https://wa.me/51999999999" },
  },
  {
    id: "69716997e52f2b01b7b8c359",
    nombre: "Renzo Pretil",
    slug: "renzo-pretil",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      'Desarrollador de negocios digitales y líder de la nueva generación en Network Marketing. Mentor en UDAXEN, co-creador de Networker Pro y prologuista de "La Fórmula del 1%", combina visión tecnológica y estrategia de campo.',
    biografia:
      'Renzo Pretil es un destacado desarrollador de negocios digitales y uno de los líderes más influyentes de la nueva generación en el Network Marketing. A su corta edad, ha alcanzado un estatus de alta relevancia en la industria, consolidándose como mentor en la Universidad UDAXEN. Su profundo entendimiento de la metodología del éxito lo llevó a escribir el prólogo del libro "La Fórmula del 1%", validando su cercanía y dominio de la filosofía de Niel Arroe.',
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/renzo-pretil.png",
    socialLinks: { linkedin: "https://linkedin.com", instagram: "https://instagram.com", youtube: "https://youtube.com" },
  },
  {
    id: "69716997e52f2b01b7b8c35a",
    nombre: "Ruth Bartra",
    slug: "ruth-bartra",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    biografia:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/ruth-bartra.png",
    socialLinks: { facebook: "https://facebook.com", instagram: "https://instagram.com" },
  },
  {
    id: "69716997e52f2b01b7b8c35b",
    nombre: "Ruth Salinas",
    slug: "ruth-salinas",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    biografia:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/ruth-salinas.png",
    socialLinks: { instagram: "https://instagram.com", tiktok: "https://tiktok.com" },
  },
  {
    id: "69716997e52f2b01b7b8c35c",
    nombre: "Susan Gomez",
    slug: "susan-gomez",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    biografia:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/susan-gomez.png",
    socialLinks: { facebook: "https://facebook.com", instagram: "https://instagram.com", whatsapp: "https://wa.me/51999999999" },
  },
  {
    id: "69716997e52f2b01b7b8c35d",
    nombre: "Yeni Cardenas",
    slug: "yeni-cardenas",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    biografia:
      "Conferencista Internacional en Motivación Personal, Liderazgo y Desarrollo Empresarial | Networker Global Mentor en la Universidad UDAXEN.",
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/yeni-cardenas.png",
    socialLinks: { instagram: "https://instagram.com", tiktok: "https://tiktok.com" },
  },
  {
    id: "61f70f6c236ff004ec24c652",
    nombre: "DR. Paul García",
    slug: "dr-paul-garcia",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      "Médico cirujano y especialista en Biodescodificación y Bioneuroemoción. Creador del Coaching Biológico; como mentor en UDAXEN, trabaja el alto rendimiento desde la salud emocional y el equilibrio mental.",
    biografia:
      "Dr. Paul García es médico cirujano de profesión con una visión integral del bienestar humano. Especialista en Biodescodificación y Bioneuroemoción, cuenta con estudios avanzados realizados en Cuba y con el reconocido Enric Corbera. Es el creador de la metodología de Coaching Biológico, herramienta con la que ayuda a los líderes a identificar y sanar los bloqueos emocionales que afectan su salud y su éxito financiero.",
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/PAUL+GARCIA.jpg",
    socialLinks: { facebook: "https://facebook.com", youtube: "https://youtube.com", linkedin: "https://linkedin.com" },
  },
  {
    id: "61f70f60e9ae692094226d21",
    nombre: "Diego Arias",
    slug: "diego-arias",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      'Conferencista internacional de liderazgo y fundador del SER (Sistema Educativo de Redes). Mentor en UDAXEN, destaca por su comunicación y enfoque en transformar el "ser" para lograr éxito integral.',
    biografia:
      'Diego Arias Zapata es un influyente conferencista internacional de liderazgo, reconocido como uno de los diez oradores más jóvenes del mundo. Fundador del SER (Sistema Educativo de Redes) y Gerente General de World Talent, Diego destaca por su capacidad de unir el desarrollo humano con la estrategia empresarial. Actualmente, como mentor de la Universidad UDAXEN, aporta su maestría en comunicación y su enfoque en la transformación del "ser" para guiar a los estudiantes hacia un éxito integral.',
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/DIEGO+AREAS.jpg",
    socialLinks: { instagram: "https://instagram.com", youtube: "https://youtube.com" },
  },
  {
    id: "689a20ec6cc6f51833fe790b",
    nombre: "Rosalínda Chavez",
    slug: "rosalinda-chavez",
    rango: "Embajador Corona",
    stats: { estudiantes: 2000, exp: 17 },
    bio: "Networker Global Mentor en la Universidad UDAXEN.",
    informacion:
      "Miembro del consejo del SIF en Latinoamérica, enfocada en equidad y valores humanos. Mentora en UDAXEN, promueve modelos de negocio con ética, responsabilidad social e impacto positivo.",
    biografia:
      "Rosalinda Chávez es miembro del consejo del SIF en Latinoamérica, organización dedicada a fomentar comunidades pacíficas y prósperas. Como mentora de la Universidad UDAXEN, Rosalinda guía a los emprendedores para integrar la ética y la responsabilidad social en sus modelos de negocio. Su enfoque asegura que el crecimiento financiero esté siempre alineado con un impacto positivo en la sociedad, formando líderes con un propósito que trasciende lo económico.",
    perfil:
      "https://shirleyarroe.s3.us-east-1.amazonaws.com/udaxen2/instructor/ROSALINDA.jpg",
    socialLinks: { facebook: "https://facebook.com", instagram: "https://instagram.com", whatsapp: "https://wa.me/51999999999" },
  },
];